import type { ComposerStore } from '../composerStore'

/**
 * Non-React code (the Plate text-sync plugin) needs to know whether the
 * bridge is mounted and where to write. The bridge hook registers the store
 * while mounted, making registration the single source of truth for
 * "Zustand is accepting omni writes" without a hook in the plugin.
 */
let omniTarget: ComposerStore | null = null

export function registerOmniWriteTarget(store: ComposerStore): () => void {
  omniTarget = store
  return (): void => {
    omniTarget = null
  }
}

export function getOmniWriteTarget(): ComposerStore | null {
  return omniTarget
}
